
export const environment = {
  env: 'staging',
  production: true,
  serverUrl: 'https://api.live.eyeqmarketplace.com',
  authMSServerUrl: 'https://app.live.eyeqmarketplace.com/api/auth/v2',
  hereMaps: {
    appId: 'a039PsbmOiOsbfpu5oIw',
    apiKey: 'e7Y2bpUwyL-a7TbhPFZG5bVY722JIG1Tz4eOZL7oXCo'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyDbt8JrlbCcwqK0aIMui5vIzea0Xn3nWH0',
    authDomain: 'eyeq-prod-8e842.firebaseapp.com',
    databaseURL: 'https://eyeq-prod-8e842-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'eyeq-prod-8e842',
    storageBucket: 'eyeq-prod-8e842.firebasestorage.app',
    messagingSenderId: '1051167453841',
    appId: '1:1051167453841:web:11d68527e491bbd2fa0530',
    measurementId: 'G-KVMP5FK6Y1'
  },
  firebaseVapidKey: 'BKzb_aGxqFi2hdmeyrWAPJcriEQts4n96iQPlGHiCX6g_Lo_VheOy-QIWI_Q-AN7cfVwVdzecWHdP3cfmyytsR4',
  optimizely: {
    sdkKey: '5LyUdF3ce6jbWogqRVp2H',
    useLocalFeatureFlagJson: false,
	},
	marketplace: { jobExpireBeforeFirstStopInMinutes: '-60' },
	mixpanel: { token: 'a56fe513bd07957a9f5a4cea63ec2e59' },
  googleTagId: 'G-RP15NYWQ9K',
	sentry: {
    enabled: true,
	  dsn: 'https://50220bb79ec93cecdc299d0ad3ec3eaf@o4509333534736384.ingest.de.sentry.io/4510420576698448',
	  sampleRate: '1',
	  replaysSessionSampleRate: '1',
	  replaysOnErrorSampleRate: '1',
  },
  timeoutBeforeVerificationBannerInMs: undefined,
  zendeskWidgetId: 'undefined',
  zendeskCompanyNameFieldId: '12934966520477',
  project: 'undefined',
  projectEnvironment: 'undefined',
};
